import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { PlusIcon, NoSymbolIcon } from "@heroicons/react/24/outline";
import api from "../../api";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Table, { PageControler } from "../../components/Table";

const columns = [
    {
        name: "name",
        displayText: "Nombre y Apellido",
        clickable: true,
        truncate: true,
    },
    { name: "govId", displayText: "C.I." },
    { name: "age", displayText: "Edad" },
    { name: "sex", displayText: "Sexo" },
    { name: "city", displayText: "Ciudad    " },
    { name: "lastConsultationDate", displayText: "Última visita" },
];

const PAGE_SIZE = 20;

export default function PatientPage() {
    // eslint-disable-next-line no-unused-vars
    const [patientsError, setPatientsError] = useState("");
    const [patients, setPatients] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [search, setSearch] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [cities, setCities] = useState([]);
    const [page, setPage] = useState(1);
    const [next, setNext] = useState(null);
    const [previous, setPrevious] = useState(null);

    // getting initial data
    useEffect(() => {
        api.cities.getMulti().then((response) => {
            setCities(response);
            setLoading(false);
            // api.patients.getMulti('modification', search, null, null, null).then((resp) => (setPatients(resp.results.filter((array) => { return array.firstName ? true : false }).map((element) => {
            //     return ({ ...element, name: element.firstName + ' ' + element.lastName, city: response.find((city) => city.id === element.city)?.name, sex: element.sex === 1 ? 'Masculino' : 'Femenino' })
            // })), setTotal(resp.count), setLoading(false)))
        });
    }, []);

    useEffect(() => {
        setPage(1);
    }, [search]);

    useEffect(() => {
        if (!search) {
            if (search === "") {
                setPatients([]);
                setTotal(0);
                setNext(null);
                setPrevious(null);
            }
            return;
        }

        setLoading(true);

        api.patients
            .getMulti("alphabetic", search, null, null, { page })
            .then((response) => {
                setNext(response.next);
                setPrevious(response.previous);
                setTotal(response.count);

                setPatients(
                    response.results
                        .filter((p) => !!p.firstName)
                        .map((element) => ({
                            ...element,
                            name: `${element.firstName} ${element.lastName}`,
                            city: cities.find((c) => c.id === element.city)
                                ?.name,
                            sex: element.sex === 1 ? "Masculino" : "Femenino",
                        })),
                );
            })
            .catch((e) => {
                // si querés mostrar mensaje real, depende de la forma de e.message en tu api.js
                setPatientsError(e?.message || "Error al cargar pacientes");
            })
            .finally(() => setLoading(false));
    }, [search, page, cities]);

    const totalPages = Math.ceil(total / PAGE_SIZE);

    const start = total === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
    const end = Math.min(page * PAGE_SIZE, total);

    // const pages = Array.from({ length: totalPages }, (_, i) => ({
    //     number: i + 1,
    //     current: i + 1 === page,
    // }));

    return (
        <div className="bg-gray-100 dark:bg-gray-800 h-screen">
            <Sidebar
                currentScreen={"Pacientes"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                {loading ? (
                    <div className="flex h-full items-center justify-center ">
                        <div className="w-16 h-16 border-b-2 border-blue-900 dark:border-white rounded-full animate-spin"></div>
                    </div>
                ) : (
                    <>
                        <div className="bg-gray-100 dark:bg-gray-800 z-10">
                            <Header
                                value={search}
                                search={true}
                                setSearch={setSearch}
                                setSidebarOpen={setSidebarOpen}
                                searchPlaceholder="Buscar por nombre o número de documento."
                                buttonText={
                                    patients.length ? "Nuevo paciente" : null
                                }
                                href="/patients/new"
                            />
                            {patientsError && (
                                <div className="mb-3 mx-10 text-sm text-red-600">
                                    {patientsError}
                                </div>
                            )}
                        </div>
                        <main className="flex-1 bg-gray-100 dark:bg-gray-800 overflow-y-auto">
                            {patients.length ? (
                                <div className="pt-4 pb-10">
                                    <div className="max-w-7xl mx-auto ml-2 px-4 mb-4 sm:px-6 md:px-8">
                                        <h1 className="text-2xl font-bold leading-9 text-gray-600 dark:text-gray-400">
                                            Total de pacientes registrados:{" "}
                                            {total}
                                        </h1>
                                    </div>
                                    <div className="px-4 sm:px-6 md:px-8">
                                        <Table
                                            module="patients"
                                            actiontext="Ver"
                                            columns={columns}
                                            rows={patients}
                                        />
                                        <PageControler start={start} end={end} total={total} page={page} totalPages={totalPages} setPage={setPage} previous={previous} next={next}/>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex h-full">
                                    <div className="mx-auto my-auto text-center">
                                        <NoSymbolIcon
                                            className="h-12 w-12 mx-auto text-gray-400"
                                            aria-hidden="true"
                                        />
                                        <h3 className="mt-2 text-sm font-semibold text-gray-800 dark:text-gray-200">
                                            No se encontraron resultados
                                        </h3>
                                        <p className="mt-1 text-sm font-semibold text-gray-600 dark:text-gray-400">
                                            Probá con otros datos o registrá un
                                            nuevo paciente.
                                        </p>
                                        <div className="mt-6">
                                            <Link
                                                to="/patients/new"
                                                type="button"
                                                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary"
                                            >
                                                <PlusIcon
                                                    className="-ml-1 mr-2 h-5 w-5"
                                                    aria-hidden="true"
                                                />
                                                Nuevo paciente
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </main>
                    </>
                )}
            </div>
        </div>
    );
}
